export default __webpack_public_path__ + "static/hypershift_screen_1-f3734535817800e15cbc17283f7cfc7b.svg";